export default __webpack_public_path__ + "static/media/3.d0ef809b.jpg";